import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DepositNotes } from "@app/models/deposit-notes";
import { DepositNotesService } from "@app/services/deposit-notes.service";

@Component({
    selector: "app-select-deposit-note-popup",
    templateUrl: "./select-deposit-note-popup.component.html",
    styleUrls: ["./select-deposit-note-popup.component.css"],
    standalone: false
})
export class SelectDepositNotePopupComponent implements OnInit {
  @Input() depositNotes: Array<DepositNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedDepositNotes: Array<DepositNotes>;
  @Output() onSubmit = new EventEmitter<Array<DepositNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private depositNotesService: DepositNotesService) {}

  ngOnInit() {
    if (!this.selectedDepositNotes) {
      this.selectedDepositNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(depositNote) {
    if (depositNote) {
      const parentIds = this.depositNotesService.findDepositNoteParents(depositNote, this.depositNotes);
      this.selectedDepositNotes = [
        ...this.selectedDepositNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedDepositNotes.push(depositNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedDepositNotes);
  }

  deleteSelectedDepositNote(depositNote) {
    if (depositNote) {
      let children = this.findAllChildren(depositNote);
      this.selectedDepositNotes = this.selectedDepositNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (depositNote.parentDepositNoteId) {
        let parent = this.depositNotesService.findDepositNoteById(depositNote.parentDepositNoteId, this.depositNotes);
        this.selectedDepositNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: DepositNotes[], depositNote: DepositNotes) {
    const set1 = new Set(checkArray);
    const originalDepositNote = this.depositNotesService.findDepositNoteById(depositNote.id, this.depositNotes);
    const parents = this.depositNotesService.findDepositNoteParents(originalDepositNote, this.depositNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChildren(depositNote: DepositNotes) {
    var items = [];
    if (depositNote) {
      items.push(depositNote);
      if (depositNote.subDepositNotes && depositNote.subDepositNotes.length > 0) {
        depositNote.subDepositNotes.forEach((p) => {
          items = items.concat(this.findAllChildren(p));
        });
      }
    }
    return items;
  }
}
